import { Action } from 'redux'
import { IRoom } from '../../../models/Room'
import { RoomActions } from '../../../reducers/bookingCalendar/actionNames'

const requestDataForRooms = (): IRequestDataForRooms => ({
  type: RoomActions.RequestDataForRooms,
})

export default requestDataForRooms
export type IRequestDataForRooms = Action<RoomActions.RequestDataForRooms>

export const dataForRoomsIsAccepted = (
  data: IRoom[],
  putToDB = true,
  clear = false,
): IDataForRoomsIsAccepted => ({
  clear,
  putToDB,
  rooms: data,
  type: RoomActions.DataForRoomsAccepted,
})

export interface IDataForRoomsIsAccepted
  extends Action<RoomActions.DataForRoomsAccepted> {
  rooms: IRoom[]
  putToDB: boolean
  clear?: boolean
}

export const dataForRoomsIsRejected = (
  errMessage: string,
): IDataForRoomsIsRejected => ({
  errMessage,
  type: RoomActions.DataForRoomsRejected,
})

export interface IDataForRoomsIsRejected
  extends Action<RoomActions.DataForRoomsRejected> {
  errMessage: string
}

export const databaseForRoomsIsEmpty = (
  lastModifyDate?: Date,
): IDatabaseForRoomsEmpty => ({
  lastModifyDate,
  type: RoomActions.DatabaseForRoomsIsEmpty,
})

export interface IDatabaseForRoomsEmpty
  extends Action<RoomActions.DatabaseForRoomsIsEmpty> {
  lastModifyDate?: Date
}
